export class ApplicationListApplicationTabSearchTable {

    public id: number;
    public owners: [];
    public legalName: string;
    public opportunity: string;
    public vendorName: string;

    constructor(data: any) {
        this.id = data.id;
        this.owners = data.owners;
        this.legalName = data.legalName;
        this.opportunity = data.opportunity;
        this.vendorName = data.vendorName;
    }

    get ownersName() {
        let ownersNames = '';
        this.owners.forEach((owner: any) => {
            ownersNames += ', ' + owner.name;
        });

        return ownersNames.substr(1, ownersNames.length);
    }

    get ownersCell() {
        let cel = '';
        this.owners.forEach((owner: any) => {
            cel += ', ' + owner.cel;
        });

        return cel.substr(1, cel.length);
    }

    get ownersEmail() {
        let email = '';
        this.owners.forEach((owner: any) => {
            email += ', ' + owner.email;
        });

        return email.substr(1, email.length);
    }

    get ownersPhone() {
        let phone = '';
        this.owners.forEach((owner: any) => {
            phone += ', ' + owner.phone;
        });

        return phone.substr(1, phone.length);
    }
}
